enum Faction {
  Alliance = 1 << 0,
  Horde = 1 << 1
}

export default Faction
